import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {SelectFilterElement} from "../../../../../../../components/common/select-filter/select-filter.model";
import {MomentUtils} from "../../../../../../../shared/utils/moment.utils";

@Component({
    selector: 'app-medical-record-sport-year-input',
    templateUrl: './medical-record-sport-year-input.component.html',
})
export class MedicalRecordSportYearInputComponent implements OnInit {

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;

    elements: BehaviorSubject<SelectFilterElement<number, number>[]> = new BehaviorSubject<SelectFilterElement<number, number>[]>([]);

    constructor() {
        let values: number[] = [];
        for (let i = MomentUtils.currentYear() + 1; i > MomentUtils.currentYear() - 90; i--) {
            values.push(i);
        }
        this.elements.next(values.map(value => new SelectFilterElement(value, value, value)));
    }

    ngOnInit() {
    }

}
